// extracted by mini-css-extract-plugin
export default {"AnswersList":"AnswersList_AnswersList__JeSdJ"};